<template>
    <div class="col-xl-3 col-sm-6">
        <div class="card border shadow-none">
        <div class="card-body p-3">
            <div class="d-flex mb-2 pb-1 border-bottom">
            <div class="avatar flex-shrink-0 me-2">
                <img
                :src="productBrand.productBrandImageSrc"
                alt=""
                @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                class="img-thumbnail rounded-circle border-0"
                />
            </div>
            <div
                class="flex-grow-1r align-self-center overflow-hidden"
            >
                <h5 class="mb-0 text-truncate">
                <b-link
                    @click="() => this.$emit('edit', productBrand)"
                    class="text-primary font-size-14 fw-bold"
                >
                    {{productBrand.productBrandName}}</b-link
                >
                </h5>
                <p class="small">Product Brand</p>
            </div>
            </div>

            <div class="d-flex justify-content-between">
            <p class="mb-0 text-dark small fw-bold">Item Count:</p>
            <p class="mb-0 text-dark small fw-bold">{{productBrand.itemCount}}</p>
            </div>
        </div>
        <!-- end card body -->
        <div class="btn-group btn-icon" role="group">
            <button
            class="btn btn-outline-light"
             @click="() => this.$emit('delete', productBrand)"
            >
            <i class="text-danger mdi mdi-delete"></i>
            </button>
        </div>
        </div>
        <!-- end card -->
    </div>
    <!-- end col -->
</template>

<script>
export default {
    props: ['productBrand']
}
</script>